<script setup lang="ts">
const props = defineProps<{
	minVal: number
	maxVal: number
	label?: EFormLabel
	timeframe: EContactFormRentalTimeframe
}>()
const { isMobile_xl } = useWindowWidth()
</script>

<template>
	<section id="contact-form" class="contact">
		<h3 data-aos="fade-up" class="contact__title">{{ $t('modules.long_term_page_module.long_term_page_contact.fill_out_the_form') }}</h3>
		<div data-aos="fade-up" class="contact__phone">
			<div class="contact__phone-icon">
				<GlobalIcon name="call" :width="isMobile_xl ? 14 : 18" />
			</div>
			<div class="contact__phone-help">
				<span>{{ $t('modules.long_term_page_module.long_term_page_contact.need_help') }}</span>
				<span>{{ $t('modules.long_term_page_module.long_term_page_contact.call_us_24_7') }}</span>
			</div>
			<a href="tel:+48794500550">+48 794 500 550</a>
		</div>
		<LongTermPageContactForm :min-val="props.minVal" :max-val="props.maxVal" :label="label" :timeframe="timeframe" />
	</section>
</template>

<style scoped lang="scss">
@import './LongTermPageContact.scss';
</style>
